import React, { memo } from 'react';
import { DropTargetMonitor, useDrop } from 'react-dnd';

import { CalendarFullDayActivity, DraggableType } from '~/Screens/Calendar/CalendarView/components';
import { IEvent } from '~/Models/DTO/Event.model';
import { IDraggableEvent } from '~/Screens/Calendar/interfaces';

interface ICalendarDayHeader {
  width: number;
  isPast: boolean;
  events?: IEvent[];
  children?: React.ReactNode;
  className: string;
  daysOffset?: number;
  updateFullDayActivity: (item: IDraggableEvent, monitor: DropTargetMonitor) => void;
}

export const CalendarDayHeader = memo(
  ({
    width,
    isPast,
    events,
    children,
    className,
    daysOffset = 0,
    updateFullDayActivity,
  }: ICalendarDayHeader) => {
    const [, drop] = useDrop(
      () => ({
        accept: DraggableType.FULL_DAY_ACTIVITY,
        drop: updateFullDayActivity,
        canDrop: () => !isPast,
      }),
      [updateFullDayActivity, isPast],
    );

    return (
      <div ref={drop} className={className} style={{ maxWidth: width }}>
        {children}
        <CalendarFullDayActivity daysOffset={daysOffset} width={width} events={events} />
      </div>
    );
  },
);
